// src/routes/KaafiPayRoutes.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import KaafiyeIDCard from '../pages/Idcard/Kaafiye';

const IDCardRoutes = () => {
  return (
    <Routes>
      <Route path="/id/:id" element={<KaafiyeIDCard />} />
    </Routes>
  );
};

export default IDCardRoutes;
